import * as React from 'react';
export const briSvg = React.forwardRef(function briSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#00529C',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M23.561 5H8.426C6.59 5 5.1 6.54 5.1 8.44v15.12c0 1.882 1.462 3.41 3.275 3.439h15.178c1.838 0 3.328-1.54 3.328-3.439l.007-15.121c0-1.9-1.49-3.44-3.327-3.44ZM10.226 25.237l-.826.01c-1 0-1.81-.83-1.81-1.851l-.005-.146V9.285l.006-.752c.037-.99.782-1.786 1.758-1.786h1.678c1.521 0 2.755 1.334 2.755 2.91a2.89 2.89 0 0 1-.792 1.998l-4.283 4.384 4.014 4.124c.518.538.83 1.246.83 2.02 0 1.687-1.489 3.054-3.325 3.054Zm12.34-.014-7.484-.003s.865-1.887.865-3.055c0-1.423-.472-2.696-1.21-3.538l-2.56-2.632 2.613-2.724c.777-.737 1.294-2.046 1.294-3.538 0-1.18-.324-2.226-.845-2.986h1.813c1.522 0 2.756 1.334 2.756 2.91a2.89 2.89 0 0 1-.792 1.998l-4.201 4.338 8.725 8.977c-.276.176-.625.253-.974.253Zm1.827-2.802-6.253-6.43 2.978-3.053c.607-.765.991-1.917.991-3.205 0-1.188-.328-2.26-.854-3.02l1.333.04c1 0 1.81.83 1.81 1.852l-.005 13.816Z',
      fill: '#fff',
    }),
  );
});
briSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var bri = {
  category: 'brand',
  colorable: false,
  name: 'bri',
  svg: briSvg,
};
